import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import { ProjectLink, Registration, Projects, Templates, Exports, ProjectJSON, DefaultProjectJSON, AssetsData, UploadAssetsData, createThumbnailData, exportProjectData, webHookData, createSubtitleData, subtitleWebhookData, projectHistoryData, tempUserPlan, translateWebhookData, userWorkSpaceListData, workspace_memberData, workspaceProjectData, workspace_invitationData, user_config } from '../provider/api_data/api.config';
// import mime from "mime-types";

export const BASE_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_URL
export const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL
export const SERVER_STATUS = process.env.REACT_APP_SERVER_STATUS
export const CLOUD_PROVIDER = process.env.REACT_APP_CLOUD_PROVIDER

export const PostRegistrationContactUs = async (formData) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    try {
      const res = await axios({
        method: 'post', // Changed to POST to send data
        url: BASE_BACKEND_URL + '/registration/contact_us/',
        data: formData, // Passing the form fields
        withCredentials: true,
      });
      
      resultState.state = 'success';
      resultState.data = res.data;
    } catch (err) {
      resultState.state = 'error';
      // Safely capture the error message from Django or Axios
      resultState.data['message'] = err.response?.data?.message || err.message;
    }
  } else {
    // Mocking a successful response for local development
    console.log("Local Mode: Form Data submitted:", formData);
    resultState.state = 'success';
    resultState.data = { message: "Mock success from localhost" };
  }

  return resultState;
}

export const GetRegistration = async () => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + '/registration/me/',
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Registration;
  }

  return resultState;
}

// The signed-in user's Vertical OTT Key — the token others use to watch their
// vertical feed in the mobile app. Created lazily on first request.
export const GetMyVerticalOttKey = async () => {
  let resultState = { state: '', data: {} };
  await axios({
    method: 'get',
    url: BASE_BACKEND_URL + '/vertical/ott-key/',
    withCredentials: true,
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data['message'] = err.message;
  })
  return resultState;
}

export const GetEmailMarketing = async (marketable, notifiable) => {
  let resultState = { state: '', data: {} };
  let preferenceApi = `${BASE_BACKEND_URL}/registration/email_preferences/?marketing_email=${marketable}&notification_email=${notifiable}`;
  if (typeof marketable === 'undefined' && typeof notifiable === 'undefined'){
    preferenceApi = `${BASE_BACKEND_URL}/registration/email_preferences/`;
  }
  await axios({
    method: 'get',
    url: preferenceApi,
    data: {},
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data = err.data;
  });
  return resultState;
}

export const verifyLoginCode = async (projectUUID) => {
  let resultState = { state: '', data: {} };
  let userdata = { "email": document.getElementById('email_input').value, "code": document.getElementById('code_input').value };

  let project_uuid = projectUUID ? projectUUID : "";

  await axios({
    method: 'post',
    url: `${BASE_BACKEND_URL}/registration/verify_login_code`,
    data: userdata,
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data = err.response.data;
  })

  return resultState;
};

export const requestSignInCode = async (projectUUID) => {
  let resultState = { state: '', data: {} };

  let email = document.getElementById('email_input').value;
  let project_uuid = projectUUID ? projectUUID : "";

  await axios({
    method: 'get',
    url: `${BASE_BACKEND_URL}/registration/request_sign_in_code?email=${encodeURIComponent(email)}&project_uuid=${project_uuid}`,
    data: {},
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data = err.response.data;
  })

  return resultState;
};

export const requestSignUpCode = async (projectUUID) => {
  let resultState = { state: '', data: {} };

  let username = document.getElementById('email_input').value;
  let name_input = document.getElementById('name_input');
  let name = name_input ? name_input.value : "";
  let surname_input = document.getElementById('surname_input');
  let surname = surname_input ? surname_input.value : "";
  let project_uuid = projectUUID ? projectUUID : "";

  let user_data = { "email": username, "name": name, "surname": surname, "username": username, "project_uuid": project_uuid };

  await axios({
    method: 'post',
    url: `${BASE_BACKEND_URL}/registration/request_sign_up_code`,
    data: user_data,
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data.code = res.data.code;
    resultState.data.status = res.status;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data = err.response.data;
  })

  return resultState;
};

export const requestAccountDeletion = async (email) => {
  let resultState = { state: '', data: {} };

  await axios({
    method: 'post',
    url: `${BASE_BACKEND_URL}/registration/request_account_deletion`,
    data: { email },
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data = err.response ? err.response.data : {};
  })

  return resultState;
};

export const confirmAccountDeletion = async (email, code) => {
  let resultState = { state: '', data: {} };

  await axios({
    method: 'post',
    url: `${BASE_BACKEND_URL}/registration/confirm_account_deletion`,
    data: { email, code },
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data = err.response ? err.response.data : {};
  })

  return resultState;
};

export const EmailSendEmailMagicLinkForSignIn = async (projectUUID) => {
  let resultState = { state: '', data: {} };

  let username = document.getElementById('email_input').value;
  let project_uuid = projectUUID ? projectUUID : "";

  await axios({
    method: 'get',
    url: `${BASE_BACKEND_URL}/registration/get_magic_link_for_sign_in/?username=${username}&project_uuid=${project_uuid}`,
    data: {},
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data = err.data;
  })

  return resultState;
}

export const EmailSendEmailMagicLinkForSignUp = async (projectUUID) => {
  let resultState = { state: '', data: {} };

  let username = document.getElementById('email_input').value;
  let name_input = document.getElementById('name_input');
  let name = name_input ? name_input.value : "";
  let surname_input = document.getElementById('surname_input');
  let surname = surname_input ? surname_input.value : "";
  let project_uuid = projectUUID ? projectUUID : "";

  await axios({
    method: 'get',
    url: `${BASE_BACKEND_URL}/registration/get_magic_link_for_sign_up/?username=${username}&email=${username}&name=${name}&surname=${surname}&project_uuid=${project_uuid}`,
    data: {},
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data['message'] = err.message;
  })

  return resultState;
}

export const GetProjectLink = async (callBack) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/project/`,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    });
  } else {
    resultState.state = 'success';
    resultState.data = ProjectLink;
  }

  return resultState;
}

export const CreateVoiceClone = async (filename, target_lang, opts) => {
  let resultState = { state: '', data: {} };

  let user_data = getAccessToken();
  let customer_data = {
    user: user_data
  };

  let url = `${BASE_BACKEND_URL}/voiceclone/?filename=${filename}&target_lang=${target_lang}`;
  if (opts && opts.existing_asset_uuid) {
    url += `&existing_asset_uuid=${encodeURIComponent(opts.existing_asset_uuid)}`;
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: customer_data,
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
      uuid: uuidv4(),
    };
  }

  return resultState;
}

export const UpdateVoiceClone = async (voiceclone_uuid, state, config) => {
  let resultState = { state: '', data: {} };

  let user_data = getAccessToken();
  let url = `${BASE_BACKEND_URL}/voiceclone/${voiceclone_uuid}`;
  let customer_data = { 
    user: user_data,
    uuid: voiceclone_uuid,
    config: config,
    state: state
  };
  
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: url,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      if (err.response?.status === 402 && err.response?.data?.code === 'INSUFFICIENT_CREDITS') {
        resultState.data.code = 'INSUFFICIENT_CREDITS';
      } else {
        resultState.data['message'] = err.message;
      }
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
      uuid: uuidv4(),
    };
  }

  return resultState;
}

export const DeleteVoiceClone = async (voiceclone_uuid, flag) => {
  let resultState = { state: "", data: {} };

  let user_data = getAccessToken();
  let delete_asset = !!flag;

  let url = `${BASE_BACKEND_URL}/voiceclone/delete/${voiceclone_uuid}`;

  let customer_data = {
    user: user_data,
    uuid: voiceclone_uuid,
    deleteAsset: delete_asset,
  };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: url,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
      uuid: uuidv4(),
    };
  }
  return resultState;
};

export const RedubVoiceClone = async (voiceclone_uuid, target_language, target_language_initials, language_model) => {
  let resultState = { state: "", data: {} };

  let user_data = getAccessToken();
  let url = `${BASE_BACKEND_URL}/voiceclone/reclone/${voiceclone_uuid}`;

  let customer_data = {
    user: user_data,
    new_target_lang: target_language,
    new_target_lang_initials: target_language_initials,
    new_target_lang_model: language_model,
  };

 
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: url,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
      uuid: uuidv4(),
    };
  }
  return resultState;
};

export const GetVoiceCloneSubtitles = async (voiceCloneUUID) => {
  let resultState = { state: '', data: {} };

  let user_data = getAccessToken();
  let customer_data = { 
    user: user_data
  };

  let url = `${BASE_BACKEND_URL}/voiceclone/${voiceCloneUUID}/subtitles/`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: customer_data,
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  }
  return resultState;
}
export const GetVoiceCloneTranslation = async (voiceCloneUUID) => {
  let resultState = { state: '', data: {} };

  let user_data = getAccessToken();
  let customer_data = {
    user: user_data
  };

  let url = `${BASE_BACKEND_URL}/voiceclone/${voiceCloneUUID}/translations/`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: customer_data,
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  }
  return resultState;
}

export const GetVoiceClonePublicShare = async (uuid) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/voiceclone/share/${uuid}/`,
      data: { user: getAccessToken() },
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    });
  }
  return resultState;
}

export const GetVoiceCloneDetail = async (uuid) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/voiceclone/${uuid}/`,
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    });
  }
  return resultState;
}

// ── Transcript (transcription-only; AKS) ─────────────────────────────────────
export const CreateTranscript = async (filename, target_lang, opts) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data };
  let url = `${BASE_BACKEND_URL}/transcript/?filename=${filename}&target_lang=${target_lang || ''}`;
  if (opts && opts.existing_asset_uuid) {
    url += `&existing_asset_uuid=${encodeURIComponent(opts.existing_asset_uuid)}`;
  }
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url, data: customer_data, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  } else { resultState.state = 'success'; resultState.data = { uuid: uuidv4() }; }
  return resultState;
}

export const UpdateTranscript = async (transcript_uuid, state, config) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let url = `${BASE_BACKEND_URL}/transcript/${transcript_uuid}`;
  let customer_data = { user: user_data, uuid: transcript_uuid, config, state };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'post', url, data: customer_data, headers: { 'Content-Type': 'application/json' } })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => {
        resultState.state = 'error';
        if (err.response?.status === 402 && err.response?.data?.code === 'INSUFFICIENT_CREDITS') {
          resultState.data.code = 'INSUFFICIENT_CREDITS';
        } else { resultState.data['message'] = err.message; }
      });
  } else { resultState.state = 'success'; resultState.data = { uuid: uuidv4() }; }
  return resultState;
}

export const DeleteTranscript = async (transcript_uuid, flag) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let url = `${BASE_BACKEND_URL}/transcript/delete/${transcript_uuid}`;
  let customer_data = { user: user_data, uuid: transcript_uuid, delete_assets: !!flag };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'post', url, data: customer_data, headers: { 'Content-Type': 'application/json' } })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  } else { resultState.state = 'success'; resultState.data = { uuid: uuidv4() }; }
  return resultState;
}

// ── JumpCut ──────────────────────────────────────────────────────────────
export const CreateJumpCut = async (filename, opts) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let url = `${BASE_BACKEND_URL}/jumpcut/?filename=${filename}`;
  if (opts && opts.existing_asset_uuid) {
    url += `&existing_asset_uuid=${encodeURIComponent(opts.existing_asset_uuid)}`;
  }
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url, data: { user: user_data }, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  } else { resultState.state = 'success'; resultState.data = { uuid: uuidv4() }; }
  return resultState;
}

export const UpdateJumpCut = async (jumpcut_uuid, state, config) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/jumpcut/${jumpcut_uuid}`;
  let customer_data = { user: getAccessToken(), uuid: jumpcut_uuid, config, state };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'post', url, data: customer_data, headers: { 'Content-Type': 'application/json' } })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => {
        resultState.state = 'error';
        if (err.response?.status === 402 && err.response?.data?.code === 'INSUFFICIENT_CREDITS') {
          resultState.data.code = 'INSUFFICIENT_CREDITS';
        } else { resultState.data['message'] = err.message; }
      });
  } else { resultState.state = 'success'; resultState.data = { uuid: uuidv4() }; }
  return resultState;
}

export const getJumpCuts = async (url, pageIndex) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url: url + `?page=${pageIndex}`, data: {}, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  } else { resultState.state = 'success'; resultState.data = { results: [] }; }
  return resultState;
}

export const DeleteJumpCut = async (jumpcut_uuid, flag) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/jumpcut/delete/${jumpcut_uuid}`;
  let customer_data = { user: getAccessToken(), uuid: jumpcut_uuid, delete_assets: !!flag };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'post', url, data: customer_data, headers: { 'Content-Type': 'application/json' } })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  } else { resultState.state = 'success'; resultState.data = { uuid: uuidv4() }; }
  return resultState;
}

export const GetJumpCutStatus = async (uuid) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/jumpcut/${uuid}/status/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
}

export const GetJumpCutPublicShare = async (uuid) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/jumpcut/share/${uuid}/`;
  await axios({ method: 'get', url, data: { user: getAccessToken() }, withCredentials: true })
    .then(res => { resultState.state = 'success'; resultState.data = res.data; })
    .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  return resultState;
}

export const GetTranscriptSubtitles = async (transcriptUUID) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/transcript/${transcriptUUID}/subtitles/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url, data: { user: getAccessToken() }, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
}

export const SaveTranscriptSubtitles = async (transcriptUUID, subtitles_text) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/transcript/${transcriptUUID}/subtitles/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'post', url, data: { user: getAccessToken(), subtitles_text }, headers: { 'Content-Type': 'application/json' } })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
}

export const GetTranscriptTranslation = async (transcriptUUID) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/transcript/${transcriptUUID}/translations/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url, data: { user: getAccessToken() }, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
}

export const SaveTranscriptTranslation = async (transcriptUUID, subtitles_text) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/transcript/${transcriptUUID}/translations/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'post', url, data: { user: getAccessToken(), subtitles_text }, headers: { 'Content-Type': 'application/json' } })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
}

export const GetTranscriptPublicShare = async (uuid) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url: `${BASE_BACKEND_URL}/transcript/share/${uuid}/`, data: { user: getAccessToken() }, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
}

export const GetTranscriptDetail = async (uuid) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url: `${BASE_BACKEND_URL}/transcript/${uuid}/`, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
}

export const getTranscripts = async (url, pageIndex) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url: url + `?page=${pageIndex}`, data: {}, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  } else { resultState.state = 'success'; resultState.data = { results: [] }; }
  return resultState;
}

// Build a download URL for a transcript export (srt | vtt | fcpxml | aaf).
export const TranscriptExportUrl = (uuid, fmt, track = 'subtitle') =>
  `${BASE_BACKEND_URL}/transcript/${uuid}/export/${fmt}/?track=${track}`;

// Start a burn-in render (subtitles/translation into the video via ffmpeg).
export const RenderTranscript = async (uuid, opts = {}) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/transcript/${uuid}/render/`;
  const body = {
    user: getAccessToken(),
    track: opts.track || 'subtitle',
    font: opts.font || 'DejaVu Sans',
    font_size: opts.font_size || 1,
    font_color: opts.font_color || '#FFFFFF',
    border: opts.border !== undefined ? opts.border : true,
    border_color: opts.border_color || '#000000',
    border_width: opts.border_width || 2,
    karaoke: opts.karaoke !== undefined ? opts.karaoke : false,
    karaoke_color: opts.karaoke_color || '#FFD400',
    alignment: opts.alignment || 2,
    pos_x: opts.pos_x != null ? opts.pos_x : null,
    pos_y: opts.pos_y != null ? opts.pos_y : null,
    custom_font_url: opts.custom_font_url || '',
  };
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'post', url, data: body, headers: { 'Content-Type': 'application/json' } })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
};

export const GetTranscriptRenderStatus = async (uuid, assetUuid) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/transcript/${uuid}/render/status/${assetUuid}/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
};

// Create a FONT asset for a custom subtitle font; returns upload + read URLs.
export const CreateTranscriptFont = async (filename) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/transcript/font/?filename=${encodeURIComponent(filename)}`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({ method: 'get', url, data: { user: getAccessToken() }, withCredentials: true })
      .then(res => { resultState.state = 'success'; resultState.data = res.data; })
      .catch(err => { resultState.state = 'error'; resultState.data['message'] = err.message; });
  }
  return resultState;
};

export const CreateAssets = async () => {
  let resultState = { state: '', data: {} };

  let user_data = getAccessToken();
  let url = `${BASE_BACKEND_URL}/asset/`;
  let customer_data = { 
    user: user_data
  };
  
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
      uuid: uuidv4(),
    };
  }

  return resultState;
}

export const UpdateAssets = async (asset_uuid, project_uuid, original_filename, mime_type, category, thumbnailInfo) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  // let url = BASE_BACKEND_URL + `/asset/create/${asset_uuid}?category=${category}&original_filename=${original_filename}&mime_type=${mime_type}&title=%22` + project_uuid + `%22&size=0&thumbnail_info=${thumbnailInfo}&project_uuid=${project_uuid}`;
  let url = `${BASE_BACKEND_URL}/asset/create/${asset_uuid}`;
  let customer_data = { 
    category: category,
    original_filename: original_filename,
    thumbnail_info: thumbnailInfo,
    mime_type: mime_type,
    project_uuid: project_uuid,
    title: `%22${project_uuid}%22`,
    user: user_data };
  
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: url,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
      ...AssetsData,
      uuid: uuidv4(),
      category: category,
    };
  }

  return resultState;
}

export const UploadAssets = async (P_uuid, A_uuid, onProgress) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/asset/member/?project_uuid=${P_uuid}&asset_uuid=${A_uuid}`,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = UploadAssetsData;
    resultState.data.uuid = A_uuid;
  }

  return resultState;
}

export const UploadVideo = async (file, signedurl, uploading) => {
  let resultState = { state: '', data: {} };
  const headers = { 'Content-Type': file.type };
  
  if (CLOUD_PROVIDER === 'AZURE') {
    headers['x-ms-blob-type'] = 'BlockBlob';
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'put',
      url: signedurl,
      data: file,
      headers: headers,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (typeof uploading === 'function') {
          uploading(percentCompleted);
        }
        // fallback: do nothing if not a function
      },
    })
      .then(function (response) {
        resultState.state = 'success';
      })
      .catch(function (error) {
        resultState.state = 'error';
        resultState.data.message = error.message;
        window.toastr.error(error.message);
      });
  } else {
    resultState.state = 'success';
  }

  return resultState;
};

export const UploadThumbnail = async (signedurl, image) => {

  let resultState = { state: '', data: {} };
  let headers = { };
  if (CLOUD_PROVIDER === 'AZURE') {
    headers['Content-Type'] = image.type || 'image/png';
    headers['x-ms-blob-type'] = 'BlockBlob';
  } else if (CLOUD_PROVIDER === 'GCP') {
    headers['Content-Type'] = image.type || 'image/png';
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'put',
      url: signedurl,
      data: image,
      headers: headers,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
    });
  } else {
    resultState.state = 'success';
    resultState.data = [];
  }

  return resultState;
};

export const SubtitleVideo = async (asset_uuid, project_uuid) => {
  let resultState = { state: '', data: {} };

  await axios({
    method: 'get',
    url: `${BASE_BACKEND_URL}/subtitle/submit/1/${project_uuid}/${asset_uuid}/`,
    data: {},
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data['message'] = err.message;
  })

  return resultState;
}

export const CreditSubscribe = async (info, planMonthly, stripe, userData, coupon, freeTrial) => {
  let resultState = { state: '', data: {} };
  let customer_resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data, coupon: coupon};

  await axios({
    method: 'get',
    url: BASE_BACKEND_URL + '/payment/customer',
    data: customer_data,
    withCredentials: true,
  }).then(async (res) => {
    customer_resultState.state = 'success';
    customer_resultState.data = res.data;

    let product = parseInt(info.product);

    let subscription_data = { user: user_data, coupon: coupon, is_free_trial: freeTrial,  name: userData.name, email: userData.email, surname: userData.surname, card: info.card, product: product, payment_method_id: info.payment_method_id };
    await axios({
      method: 'post',
      url: BASE_BACKEND_URL + `/payment/subscription`,
      headers: {
        "Content-Type": 'application/json'
      },
      data: subscription_data,
      withCredentials: true
    }).then(async (res) => {
      let data = res.data

      if (!data || !data.clientsecret) {
        resultState.state = 'error';
        resultState.data['message'] = data?.error || data?.Code || 'Subscription creation failed. Please try again.';
        return;
      }

      if (data.clientsecret.startsWith("seti_")) {

        await stripe.confirmCardSetup(data.clientsecret, {
          payment_method: {
            card: info.card_element,
            billing_details: info.billingDetails
          },
        }).then((result) => {
          if (result.error) {
            alert(result.error.message);

            resultState.state = 'error';
            resultState.data['message'] = result.error.message;

            console.log("stripe.confirmCardPayment result.error");
            console.log(result.error.message);
          } else {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Your Purchase is succesful",
              showConfirmButton: true,
              confirmButtonText: "Okay",
            }).then((result) => {
              if (result.isConfirmed) {

                resultState.state = 'success';
                resultState.data = res.data;
                window.location.reload();
              }
            });

          }
        }).catch((err) => {
          resultState.state = 'error';
          resultState.data['message'] = err.message;

          console.log("confirmCardSetup EXCEPTION");
          console.log(resultState.data['message']);
        })

      } else if (data.clientsecret.startsWith("pi_")) {

        await stripe.confirmCardPayment(data.clientsecret, {
          payment_method: {
            card: info.card_element,
            billing_details: info.billingDetails
          },
        }).then((result) => {
          if (result.error) {
            alert(result.error.message);

            resultState.state = 'error';
            resultState.data['message'] = result.error.message;

            console.log("stripe.confirmCardPayment result.error");
            console.log(result.error.message);
          } else {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Your Purchase is succesful",
              showConfirmButton: true,
              confirmButtonText: "Okay",
            }).then((result) => {
              if (result.isConfirmed) {

                resultState.state = 'success';
                resultState.data = res.data;
                window.location.reload();
              }
            });

          }
        }).catch((err) => {
          resultState.state = 'error';
          resultState.data['message'] = err.message;

          console.log("confirmCardPayment EXCEPTION");
          console.log(resultState.data['message']);
        })

      }

    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
      window.toastr.error(err.message);
    })

  });

  return resultState;
}

export const getCustomerPlan = async () => {
  let user_data = getAccessToken();
  let customer_data = { user: user_data };
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + '/payment/customer',
      data: customer_data,
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
      window.toastr.error(err.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = tempUserPlan;
  }

  return resultState;
}

export const getPaymentPortal = async () => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + '/payment/create_portal_session',
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
      window.toastr.error(err.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
      portal_url: 'https://billing.stripe.com/p/session/test_YWNjdF8xR0pldHdMUzZTQU5WY3LDLF90V0pmN3VvbnLPdGcwNnhaZW9GWVJQc0RkxubVL10100kGy2ksSU'
    }
  }

  return resultState;
}

export const getProjects = async (url) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Projects['localhost'];
  }

  return resultState;
}

export const getTemplates = async (url) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Templates['localhost'];
  }

  return resultState;
}

export const getExports = async (url) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Exports['localhost']; // TODO: return exports data
  }

  return resultState;
}

export const getAssets = async (url) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Exports['localhost']; // TODO: return asets data
  }

  return resultState;
}

export const getCompress = async (url) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Exports['localhost']; // TODO: return compress data
  }

  return resultState;
}

export const getVoiceClones = async (url, pageIndex) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url + `?page=${pageIndex}`,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Exports['localhost']; // return transcodes data
  }

  return resultState;
}

export const getTranscodes = async (url) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: {},
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = Exports['localhost']; // return transcodes data
  }

  return resultState;
}

export const duplicateProject = async (PROECT_UUID, newProjectType) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/project/${PROECT_UUID}/duplicate/?new_project_type=${newProjectType}`,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success'
    resultState.data = {
      'Duplicated Project uuid': '2f9c8c6f-d3e9-4f0d-a875-5d81e879b6d9',
      'Source Project uuid': '2f9c8c6f-d3e9-4f0d-a875-5d81e879b6d9'
    }
  }

  return resultState;
}

export const duplicateTemplateProject = async (PROECT_UUID, newProjectType) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/templateproject/${PROECT_UUID}/duplicate/?new_project_type=${newProjectType}`,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success'
    resultState.data = {
      'Duplicated Project uuid': '2f9c8c6f-d3e9-4f0d-a875-5d81e879b6d9',
      'Source Project uuid': '2f9c8c6f-d3e9-4f0d-a875-5d81e879b6d9'
    }
  }

  return resultState;
}

export const addTemplateProject = async (PROJECT_UUID, TEMPLATE_UUID) => {
  let resultState = {state: '', date: {}};

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/templateproject/${TEMPLATE_UUID}/add_to_current_project_via_tooltap/${PROJECT_UUID}`,
      withCredentials: true
    }).then(res => {
      console.log('addingTemplate', res);
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data = {message: err.message};
    })
  }else{
    resultState.state = 'success'
    resultState.data = {
      'Duplicated Project uuid': '2f9c8c6f-d3e9-4f0d-a875-5d81e879b6d9',
      'Source Project uuid': '2f9c8c6f-d3e9-4f0d-a875-5d81e879b6d9'
    }
  }

  return resultState;
}

export const getProjectJSONWithME = async (project_uuid) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/project/` + project_uuid + `/?include_me=true`,
      data: {},
      headers: { 'Content-Type': 'application/octet-stream' },
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = ProjectJSON[project_uuid] ? ProjectJSON : { [project_uuid]: DefaultProjectJSON };
  }

  return resultState;
}
// upload helper
export const getProjectJSON = async (project_uuid) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/project/` + project_uuid + `/`,
      data: {},
      headers: { 'Content-Type': 'application/octet-stream' },
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = ProjectJSON[project_uuid] ? ProjectJSON : { [project_uuid]: DefaultProjectJSON };
  }

  return resultState;
}

export const updateProjectJSON = async (project_uuid, projectJSON) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    let user_data = getAccessToken();
    let data = { [project_uuid]: projectJSON, user: user_data, }
    await axios({
      method: 'post',
      url: BASE_BACKEND_URL + `/project/` + project_uuid + `/`,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(function (response) {
      resultState.state = 'success'
      resultState.data = response.data
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = ProjectJSON[project_uuid] ? ProjectJSON : { [project_uuid]: DefaultProjectJSON };
  }

  return resultState
}

export const projectExportApi = async (projectUUID, size, bitrate, isAudio, isShort) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data };

  if (SERVER_STATUS !== 'localhost') {
    let apiUrl = BASE_BACKEND_URL + `/project/` + projectUUID + `/export/false/0/false/false`
    apiUrl += `?export_width=${size?.w || 0}`
    apiUrl += `&export_height=${size?.h || 0}`
    apiUrl += `&bitrate=${bitrate}`
    if (isAudio) {
      apiUrl += `&audio_only=true`
    } else {
      apiUrl += `&audio_only=false`
    }
    if (isShort) {
      apiUrl += `&ai_short=true`
    }

    await axios({
      url: apiUrl,
      method: 'get',
      headers: { 'Content-Type': 'application/octet-stream' },
      data: customer_data,
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = {};
  }

  return resultState;
}

export const createThumbnail = async (asset_uuid, timestamps, length) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/asset/${asset_uuid}/thumbnail/packsize/${length}/timestamps/"${timestamps.toString()}"/blob/`,
      data: {},
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = createThumbnailData
  }

  return resultState;
}

export const createProjectThumbnail = async (project_uuid) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/project/` + project_uuid + `/blob/thumbnail/`,
      headers: { 'Content-Type': 'application/octet-stream' },
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data,
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }
    })
  } else {
    resultState = {
      state: 'success',
      data: createThumbnailData,
    }
  }

  return resultState;
}

export const uploadThumbnail = async (signedurl, image) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'put',
      url: signedurl,
      data: image,
      headers: { 'Content-Type': 'blob' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = [];
  }

  return resultState;
}


export const createThumbnailForEditor = async (asset_uuid, timestamps, length) => {
  let resultState = { state: '', data: {} };
  const headers = { 'Content-Type': 'application/octet-stream'};
  // if (CLOUD_PROVIDER === 'AZURE') {
  //   headers['x-ms-blob-type'] = 'BlockBlob';
  // }
  // console.log("---createThumbnailForEditor----")
  // console.log("asset_uuid:", asset_uuid);
  // console.log("timestamps:", timestamps);
  // console.log("length:", length);
  // console.log("---createThumbnailForEditor----END")

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/asset/${asset_uuid}/thumbnail/packsize/${length}/timestamps/"${timestamps.toString()}"/blob/`,
      data: {},
      headers: headers,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
    });
  } else {
    resultState.state = 'success';
    resultState.data = createThumbnailData;
  }

  return resultState;
}

export const uploadThumbnailForEditor = async (signedurl, image) => {
  let resultState = { state: '', data: {} };

  // console.log("---uploadThumbnail----START")
  // console.log("signedurl:", signedurl);
  // console.log("image:", image);
  // console.log("---uploadThumbnail----END")

  let headers = { };
  if (CLOUD_PROVIDER === 'AZURE') {
    headers['Content-Type'] = image.type || 'application/octet-stream'
    headers['x-ms-blob-type'] = 'BlockBlob';
  } else if (CLOUD_PROVIDER === 'GCP') {
    headers['Content-Type'] = 'blob'
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'put',
      url: signedurl,
      data: image,
      headers: headers,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
    });
  } else {
    resultState.state = 'success';
    resultState.data = [];
  }

  return resultState;
};

export const getWebHookData = async (webhook_url) => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: webhook_url,
      data: {},
      headers: { 'Content-Type': 'application/octet-stream' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = webHookData;
  }

  return resultState;
}

// subtitle creating API start
export const createSubtitle = async (projectUUID, assetUUID, language, languageTo, flag) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data };

  let url = BASE_BACKEND_URL
  if (!flag) url += `/subtitle/submit/${projectUUID}/${assetUUID}/${language}`
  else url += `/subtitle/submit/${projectUUID}/${assetUUID}/${language}/${languageTo}/1`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: customer_data,
      withCredentials: true,
      headers: { 'Content-Type': 'application/octet-stream' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = createSubtitleData;
  }

  return resultState;
}

export const subtitleWebHookPoll = async (projectUUID, assetUUID, subtitleUUID, index, translate) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/subtitle/webhook/${subtitleUUID}/${projectUUID}/${assetUUID}/${index}`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: index === 3 ? 'post' : 'get',
      url: url,
      data: {},
      headers: { 'Content-Type': 'application/octet-stream' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    if (!translate) resultState.data = subtitleWebhookData
    else resultState.data = translateWebhookData
  }

  return resultState;
}
// subtitle creating API end

const getAccessToken = () => {
  let userData = localStorage.getItem('user_data');
  if (!!userData && userData.length) {
    userData = JSON.parse(userData);
    if (!!userData && typeof userData?.token === 'string' && !!userData.token.length)
      return { username: userData.username, uuid: userData.uuid, token: userData.token };
    else return 'AnonymousUser';
  } else return 'AnonymousUser';
}

export const getProjectHistory = async (projectUUID, type, sequence) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/project/${projectUUID}/${type}/${sequence}`;

  console.log(url);
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get', url: url, data: {},
      headers: { 'Content-Type': 'application/octet-stream' },
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = projectHistoryData;
  }

  return resultState;

}


export const getBranchName = async () => {
  let resultState = { state: '', data: {} };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + '/registration/settings/',
      headers: { 'Content-Type': 'application/octet-stream' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = { render_branch: "staging" }
  }

  return resultState;
}


// workspace apis
export const ShareProject = async (workspace_uuid, user_email, project_uuid) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/add_member/'
  url += `?workspace_uuid=${workspace_uuid}&project_uuid=${project_uuid}&user_email=${user_email}&level=2`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
    }
  }

  return resultState;
}

export const GetShareLink = async (shareUUID, assetUUID) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/share/'
  if (shareUUID) url += shareUUID
  if (assetUUID) url += `?asset_uuid=${assetUUID}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      data: { user: getAccessToken() },
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'error',
      message: 'Running on localhost'
    }
    return resultState;
  }

  return resultState;
}

export const CreateSharedAssetLink= async (shareUUID, assetUUID) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
    asset_uuid: assetUUID
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/share/${shareUUID}`,
      data: data,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
      console.log("CreateSharedAssetLink resultState:", resultState);
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  }
  return resultState;
}


export const getWorkspacesList = async () => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/get_workspaces_for_user/'

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: userWorkSpaceListData
    }
  }

  return resultState;
}

export const getMembersList = async (workspace_uuid) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/get_workspace_members/'
  url += `?workspace_uuid=${workspace_uuid}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: workspace_memberData
    }
  }

  return resultState;
}

export const getInvitationList = async (workspace_uuid) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/get_invitation_list_for_workspace/'
  url += `?workspace_uuid=${workspace_uuid}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: workspace_invitationData
    }
  }

  return resultState;
}

export const getProjectList = async (workspace_uuid) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/get_projects_for_workspace/'
  url += `?workspace_uuid=${workspace_uuid}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: workspaceProjectData
    }
  }

  return resultState;
}

export const createWorkspace = async () => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/create/'

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: "Workspace Zeng's workspace-3 is created."
    }
  }

  return resultState;
}

export const deleteWorkspace = async (workspace_uuid) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/delete/'
  url += `?workspace_uuid=${workspace_uuid}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: "Workspace with title Zeng's workspace-3 is deleted"
    }
  }

  return resultState;
}

export const transferOwner = async (workspace_uuid, user_email) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/transfer_owner/'
  url += `?workspace_uuid=${workspace_uuid}&user_email=${user_email}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: "owner changed"
    }
  }

  return resultState;
}

export const removeMember = async (workspace_uuid, user_email) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/remove_member/'
  url += `?workspace_uuid=${workspace_uuid}&user_email=${user_email}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
    }
  }

  return resultState;
}

export const removeInvitation = async (workspace_uuid, user_email) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/remove_invitation/'
  url += `?workspace_uuid=${workspace_uuid}&user_email=${user_email}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
    }
  }

  return resultState;
}

export const memberLevelChange = async (workspace_uuid, user_email, level) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/change_member_level/'
  url += `?workspace_uuid=${workspace_uuid}&user_email=${user_email}&level=${level}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: 'change level successed'
    }
  }

  return resultState;
}

export const ChangeProjectWorkspace = async (project_uuid, uuid, target) => {
  let resultState = { state: '', data: {} };
  let url = BASE_BACKEND_URL + '/workspace/operation/change_project_workspace/'
  url += `?workspace_uuid=${uuid}&project_uuid=${project_uuid}&workspace_target_uuid=${target}`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = {
        state: 'success',
        data: response.data
      }
    }).catch(function (error) {
      resultState = {
        state: 'error',
        message: error.message
      }

      window.toastr.error(error.message);
    })
  } else {
    resultState = {
      state: 'success',
      data: 'change workspace successed'
    }
  }

  return resultState;
}

export const compressVideo = async (projectUUID, options) => {
  const searchParams = new URLSearchParams(options);
  const queryString = searchParams.toString()
  const resultState = { state: '', data: {} };
  const user_data = getAccessToken();
  const customer_data = { user: user_data };

  if (SERVER_STATUS !== 'localhost') {
    let apiUrl = BASE_BACKEND_URL + `/project/` + projectUUID + `/compress/false/0/false/false?${queryString}`

    await axios({
      url: apiUrl,
      method: 'get',
      headers: {
        'Content-Type': 'application/octet-stream'
      },
      data: customer_data,
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    exportProjectData.uuid = projectUUID;
    resultState.data = exportProjectData;
  }

  return resultState;
}

export const convertVideo = async (projectUUID, options) => {
  const searchParams = new URLSearchParams(options);
  const queryString = searchParams.toString()
  const resultState = { state: '', data: {} };
  const user_data = getAccessToken();
  const customer_data = { user: user_data };

  if (SERVER_STATUS !== 'localhost') {
    let apiUrl = BASE_BACKEND_URL + `/project/` + projectUUID + `/convert/false/0/false/false?${queryString}`

    await axios({
      url: apiUrl,
      method: 'get',
      headers: {
        'Content-Type': 'application/octet-stream'
      },
      data: customer_data,
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    exportProjectData.uuid = projectUUID;
    resultState.data = exportProjectData;
  }

  return resultState;
}

export const requestTemplate = async (PROJECT_UUID, CATEGORY, VISIBILITY, SIZE, ACTIVE) => {
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/templateproject/project/${PROJECT_UUID}/${CATEGORY}/${VISIBILITY}/${SIZE}/${ACTIVE}/`

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}

export const deleteProject = async (projectUUID) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/purge/delete/project/${projectUUID}`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}

export const deleteAsset = async (assetUUID) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/purge/delete/asset/${assetUUID}`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}

export const getApikeysConfig = async () => {
  let resultState = {state: '', data: {}};
  const user_data = getAccessToken();
  const url = `${BASE_BACKEND_URL}/user/config/`;

  const data = {
    user: user_data,
  }

  if(SERVER_STATUS !== 'localhost')
    await axios({
      url: url,
      method: 'GET',
      data: data,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (err) {
      resultState = {state: 'error', message: err.message}
    })
  else {
    resultState = { state: 'success', data: user_config }
  }

  return resultState;
}

export const saveApikeysConfig = async (apiKeyData) => {
  let resultState = {state: '', data: {}};
  const url = `${BASE_BACKEND_URL}/user/config/`;
  const user_data = getAccessToken();
  const data = {
    user: user_data,
    config: apiKeyData
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: data
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (err) {
      resultState = {state: 'error', message: err.message}
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}
export const uploadtoInstagram = async (asset_uuid, instagramUsername, instagramDescription, instagramDatetime) => {
  let user_data = getAccessToken();
  let resultState = { state: '', data: {} };
  let url = `${BASE_BACKEND_URL}/planner/`;
  let data = {
    user: user_data,
    vendor: 4,
    asset_uuid: asset_uuid,
    scheduled_at: instagramDatetime,
    config: {
      instagram_username: instagramUsername,
      instagram_description: instagramDescription,
      instagram_scheduled_at: instagramDatetime
    }
  };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: url,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      if (error.name != "CanceledError") {
        window.toastr.error(error.message);
      }
    });
  } else {
    resultState.state = 'success';
    resultState.data = projectHistoryData;
  }

  return resultState;
};

export const bulkUploadToInstagram = async (scheduleItems, instagramUsername, fallbackDescription) => {
  // scheduleItems: [{ assetUuid, datetime, description? }, ...]
  const user_data = getAccessToken();
  const url = `${BASE_BACKEND_URL}/planner/bulk/`;
  const items = scheduleItems.map(({ assetUuid, datetime, description }) => ({
    vendor: 4,
    asset_uuid: assetUuid,
    scheduled_at: datetime,
    config: {
      instagram_username: instagramUsername,
      instagram_description: description != null ? description : fallbackDescription,
      instagram_scheduled_at: datetime,
    },
  }));
  if (SERVER_STATUS === 'localhost') return { state: 'success', data: { count: items.length } };
  const resp = await axios.post(url, { user: user_data, items }, { headers: { 'Content-Type': 'application/json' } });
  return { state: 'success', data: resp.data };
};

export const generateInstagramDescriptionForItem = async (aishortUuid, itemUuid, customPrompt = '') => {
  const url = `${BASE_BACKEND_URL}/aishort/${aishortUuid}/item/${itemUuid}/instagram-description/`;
  const resp = await axios.post(url, { user: getAccessToken(), custom_prompt: customPrompt }, { headers: { 'Content-Type': 'application/json' } });
  return resp.data?.description ?? null;
};

export const uploadToLinkedin = async (asset_uuid, socialAccountUuid, description, scheduledDatetime) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/`;
  const data = {
    user: getAccessToken(),
    vendor: 2,
    asset_uuid,
    scheduled_at: scheduledDatetime,
    config: {
      social_account_uuid: socialAccountUuid,
      linkedin_description: description,
    },
  };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url,
      data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState = { state: 'success', data: res.data };
    }).catch(err => {
      resultState = { state: 'error', message: err.message };
      if (err.name !== 'CanceledError') window.toastr.error(err.message);
    });
  } else {
    resultState = { state: 'success', data: {} };
  }
  return resultState;
};

export const getPlannerList = async ({ start, end } = {}) => {
  let resultState = { state: '', data: {} };
  const params = new URLSearchParams();
  if (start) params.append('start', start);
  if (end)   params.append('end',   end);
  const qs  = params.toString();
  const url = `${BASE_BACKEND_URL}/user/planners/${qs ? `?${qs}` : ''}`;
  await axios({
    url,
    method: 'GET',
    data: { user: getAccessToken() },
    withCredentials: true,
  }).then(res  => { resultState = { state: 'success', data: res.data }; })
    .catch(err => { resultState = { state: 'error',   message: err.message }; });
  return resultState;
};

export const generateLinkedinDescription = async (aishortUuid, itemUuid, existingText = '') => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/aishort/${aishortUuid}/item/${itemUuid}/linkedin-description/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url,
      method: 'POST',
      data:    { user: getAccessToken(), existing_text: existingText },
      headers: { 'Content-Type': 'application/json' },
    }).then(res  => { resultState = { state: 'success', data: res.data }; })
      .catch(err => { resultState = { state: 'error',   message: err.message }; });
  }
  return resultState;
};

export const generateInstagramDescription = async (aishortUuid, itemUuid, existingText = '', customPrompt = '') => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/aishort/${aishortUuid}/item/${itemUuid}/instagram-description/`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url,
      method: 'POST',
      data:    { user: getAccessToken(), existing_text: existingText, custom_prompt: customPrompt },
      headers: { 'Content-Type': 'application/json' },
    }).then(res  => { resultState = { state: 'success', data: res.data }; })
      .catch(err => { resultState = { state: 'error',   message: err.message }; });
  }
  return resultState;
};

export const uploadToTikTok = async (asset_uuid, socialAccountUuid, description, scheduledDatetime) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/`;
  const data = {
    user: getAccessToken(),
    vendor: 5,
    asset_uuid,
    scheduled_at: scheduledDatetime,
    config: {
      social_account_uuid: socialAccountUuid,
      tiktok_description:  description,
    },
  };
  await axios({
    method: 'post',
    url,
    data,
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
    if (err.name !== 'CanceledError') window.toastr.error(err.message);
  });
  return resultState;
};

export const uploadToTwitter = async (asset_uuid, socialAccountUuid, tweetText, scheduledDatetime) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/`;
  const data = {
    user: getAccessToken(),
    vendor: 6,
    asset_uuid,
    scheduled_at: scheduledDatetime,
    config: {
      social_account_uuid: socialAccountUuid,
      twitter_text:        tweetText,
    },
  };
  await axios({
    method: 'post',
    url,
    data,
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
    if (err.name !== 'CanceledError') window.toastr.error(err.message);
  });
  return resultState;
};

export const uploadToYoutube = async (asset_uuid, socialAccountUuid, title, description, scheduledDatetime, privacy = 'public') => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/`;
  const data = {
    user: getAccessToken(),
    vendor: 1,
    asset_uuid,
    scheduled_at: scheduledDatetime,
    config: {
      social_account_uuid:  socialAccountUuid,
      youtube_title:        title,
      youtube_description:  description,
      youtube_privacy:      privacy,
    },
  };
  await axios({
    method: 'post',
    url,
    data,
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
    if (err.name !== 'CanceledError') window.toastr.error(err.message);
  });
  return resultState;
};

export const generateYoutubeDescription = async (aishortUuid, itemUuid, existingText = '') => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/aishort/${aishortUuid}/item/${itemUuid}/youtube-description/`;
  await axios({
    url,
    method: 'POST',
    data:    { user: getAccessToken(), existing_text: existingText },
    headers: { 'Content-Type': 'application/json' },
  }).then(res  => { resultState = { state: 'success', data: res.data }; })
    .catch(err => { resultState = { state: 'error',   message: err.message }; });
  return resultState;
};

export const generateTwitterDescription = async (aishortUuid, itemUuid, existingText = '') => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/aishort/${aishortUuid}/item/${itemUuid}/twitter-description/`;
  await axios({
    url,
    method: 'POST',
    data:    { user: getAccessToken(), existing_text: existingText },
    headers: { 'Content-Type': 'application/json' },
  }).then(res  => { resultState = { state: 'success', data: res.data }; })
    .catch(err => { resultState = { state: 'error',   message: err.message }; });
  return resultState;
};

export const getSocialAccounts = async (vendor = null) => {
  let resultState = { state: '', data: {} };
  const params = vendor !== null ? `?vendor=${vendor}` : '';
  const url = `${BASE_BACKEND_URL}/planner/social-account/${params}`;
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url,
      method: 'POST',
      data:    { user: getAccessToken() },
      headers: { 'Content-Type': 'application/json' },
    }).then(res  => { resultState = { state: 'success', data: res.data }; })
      .catch(err => { resultState = { state: 'error',   message: err.message }; });
  } else {
    resultState = { state: 'success', data: { data: [] } };
  }
  return resultState;
};

// Generic planner-post creator used by the Planner Wizard.
// Builds the per-vendor `config` shape and POSTs to /planner/.
// Returns { state, data } and never raises its own toast so the caller
// can aggregate success/error reporting across a batch.
export const createPlannerPost = async ({
  vendor,
  assetUuid,
  socialAccountUuid = null,
  instagramUsername = null,
  title = '',
  caption = '',
  scheduledDatetime,
  collaborators = [],
  privacy = 'public',
  strategyUuid = null,
}) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/`;

  const scheduledIso = scheduledDatetime instanceof Date
    ? scheduledDatetime.toISOString()
    : scheduledDatetime;

  const config = {};
  if (socialAccountUuid) config.social_account_uuid = socialAccountUuid;
  if (Array.isArray(collaborators) && collaborators.length) config.collaborators = collaborators;

  switch (vendor) {
    case 1: // YouTube
      config.youtube_title = title || '';
      config.youtube_description = caption || '';
      config.youtube_privacy = privacy;
      break;
    case 2: // LinkedIn
      config.linkedin_description = caption || '';
      break;
    case 4: // Instagram
      config.instagram_username = instagramUsername || '';
      config.instagram_description = caption || '';
      config.instagram_scheduled_at = scheduledIso;
      break;
    case 5: // TikTok
      config.tiktok_description = caption || '';
      break;
    case 6: // Twitter / X
      config.twitter_text = caption || '';
      break;
    default:
      break;
  }

  const data = {
    user: getAccessToken(),
    vendor,
    asset_uuid: assetUuid,
    scheduled_at: scheduledIso,
    config,
  };
  if (strategyUuid) data.strategy_uuid = strategyUuid;

  if (SERVER_STATUS === 'localhost') {
    return { state: 'success', data: { Code: 'Success' } };
  }

  await axios({
    method: 'post',
    url,
    data,
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
  });

  return resultState;
};

// Update an existing planner post (POST /planner/<uuid>/). The backend replaces
// vendor / scheduled_at / config wholesale and re-resolves the social account
// from config, so callers must pass the existing values they want to keep
// (vendor, asset, scheduled_at) along with the full modified config.
export const updatePlannerPost = async (uuid, { vendor, assetUuid, scheduledDatetime, config }) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/${uuid}/`;

  const scheduledIso = scheduledDatetime instanceof Date
    ? scheduledDatetime.toISOString()
    : scheduledDatetime;

  const data = {
    user: getAccessToken(),
    vendor,
    asset_uuid: assetUuid,
    scheduled_at: scheduledIso,
    config,
  };

  if (SERVER_STATUS === 'localhost') {
    return { state: 'success', data: { Code: 'Success' } };
  }

  await axios({
    method: 'post',
    url,
    data,
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
  });

  return resultState;
};

// Delete a single planner post (DELETE /planner/<uuid>/).
export const deletePlannerPost = async (uuid) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/${uuid}/`;
  if (SERVER_STATUS === 'localhost') return { state: 'success', data: {} };
  await axios({
    method: 'delete',
    url,
    data: { user: getAccessToken() },
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
  });
  return resultState;
};

// Create a planner strategy (a group that owns a batch of planner posts).
export const createPlannerStrategy = async (name = '', config = {}) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/strategy/`;
  if (SERVER_STATUS === 'localhost') return { state: 'success', data: { uuid: 'local-strategy', name } };
  await axios({
    method: 'post',
    url,
    data: { user: getAccessToken(), name, config },
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data?.data || res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
  });
  return resultState;
};

// List the user's planner strategies (with item counts).
export const getPlannerStrategies = async () => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/strategy/`;
  if (SERVER_STATUS === 'localhost') return { state: 'success', data: { data: [] } };
  await axios({
    url,
    method: 'GET',
    data: { user: getAccessToken() },
    withCredentials: true,
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
  });
  return resultState;
};

// Fetch a single strategy with its associated planner items.
export const getPlannerStrategy = async (uuid) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/strategy/${uuid}/`;
  if (SERVER_STATUS === 'localhost') return { state: 'success', data: { data: { items: [] } } };
  await axios({
    url,
    method: 'GET',
    data: { user: getAccessToken() },
    withCredentials: true,
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
  });
  return resultState;
};

// Delete a strategy and (via DB cascade) all of its planner posts.
export const deletePlannerStrategy = async (uuid) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/planner/strategy/${uuid}/`;
  if (SERVER_STATUS === 'localhost') return { state: 'success', data: {} };
  await axios({
    method: 'delete',
    url,
    data: { user: getAccessToken() },
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState = { state: 'success', data: res.data };
  }).catch(err => {
    resultState = { state: 'error', message: err.message };
  });
  return resultState;
};

export const deleteAccount = async (userUUID) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/purge/delete/user/${userUUID}`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}

export const measureFileSize = async (assetUUID) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/asset/${assetUUID}/update/`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}

export const getStockSearchKeyword = async (keyword) => {
  const resp = await axios.get(`${BASE_BACKEND_URL}/stock/searchkeyword?context=${keyword}`);
  return resp.data;
}

export const getStockData = async (stockName) => {
  
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/stock/search?context=${stockName}`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}
export const getFreeSoundSearch = async () => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/stock/freesound/search_audio/?context=`;

  await axios({
    url: url,
    method: 'GET',
    withCredentials: true
  }).then(function (response) {
    resultState = { state: 'success', data: response.data }
  }).catch(function (err) {
    resultState = {state: 'error', message: err.message}
    //window.toastr.error(err.message);
  })
  
  return resultState;
}
export const getPopularPixaBayStockData = async (page) => {
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/stock/pixabay/popular_videos/?page=${page}`;

  await axios({
    url: url,
    method: 'GET',
    withCredentials: true
  }).then(function (response) {
    resultState = { state: 'success', data: response.data }
  }).catch(function (err) {
    resultState = {state: 'error', message: err.message}
    //window.toastr.error(err.message);
  })
  
  return resultState;
}

export const getPopularPexelsData = async (page) => {
  
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/stock/pexels/popular/?page=${page}`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}

export const getPexelsData = async (keyword, page, locale="en-US", orientation="landscape") => {
  
  let resultState = { state: '', data: {} };
  const url = `${BASE_BACKEND_URL}/stock/pexels/search_videos/?context=${keyword}&page=${page}&orientation=${orientation}&locale=${locale}`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      url: url,
      method: 'GET',
      withCredentials: true
    }).then(function (response) {
      resultState = { state: 'success', data: response.data }
    }).catch(function (error) {
      resultState = { state: 'error', message: error.message }
      window.toastr.error(error.message);
    })
  } else {
    resultState = { state: 'success', data: { Code: "Success" } }
  }

  return resultState;
}


export const createStock = async () => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  // let mimetype = "video/mp4"
  // if(stockdata.video_preview_url) {
  //   const extension = stockdata.video_preview_url.splite(".").reverse()[0];
  //   const mtype = mime.lookup(`.${extension}`);
  //   if(mtype) {
  //     mimetype = mtype;
  //   }
  // }
  const data = {
    user: user_data,
    // manifest: {
    //   title: stockdata.title,
    //   video_preview_url: stockdata.video_preview_url,
    //   mime_type: mimetype
    // }
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/stock/`,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}


export const updateStock = async (stockUUID, stockData) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let data = {
    user: user_data,
    manifest: {
      title: stockData.title,
      video_preview_url: stockData.video_preview_url,
      mime_type: "video/mp4"
    }
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: BASE_BACKEND_URL + `/stock/${stockUUID}/`,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}


export const getStock = async (stockUUID) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/stock/${stockUUID}`,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}

export const getPexelsStock = async (contentId) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/stock/pexels/get_video/?content_id=${contentId}`,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}

export const getAssetData = async (uuid, projectUUID) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
  }

  let url = `${BASE_BACKEND_URL}/asset/view/${uuid}/`;
  if(!!projectUUID) {
    url = `${BASE_BACKEND_URL}/project/${projectUUID}/asset/${uuid}`
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}

export const createTextToSpeech = async (type) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/texttospeech/vendor/${type}/`,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}

export const setUserlanguage = async (langCode) => {
  const url = BASE_BACKEND_URL + `/user/set_language/`;
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  if(user_data != 'AnonymousUser'){
    user_data.locale = langCode;
    localStorage.setItem('userLocale', langCode);
  }else{
    localStorage.setItem('userLocale', langCode);
  }
  
  let data = {
    user: user_data,
  };
  await axios({
    method: 'post',
    url: url,
    data: data,
    headers: { 'Content-Type': 'application/json' },
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data['message'] = err.message;
  })
}

export const updateTextToSpeech = async (type, speechUUID, config, text) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let data = {
    user: user_data,
    uuid: speechUUID,
    config,
    text
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: BASE_BACKEND_URL + `/texttospeech/vendor/${type}/${speechUUID}/`,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}

export const getCoupon = async (code) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = { user: user_data };
  await axios({
    method: 'get',
    url: BASE_BACKEND_URL + `/payment/coupon?code=${code}`,
    data,
    withCredentials: true
  }).then(res => {
    resultState.state = 'success';
    resultState.data = res.data;
  }).catch((err) => {
    resultState.state = 'error';
    resultState.data['message'] = err.message;
  })

  return resultState;
}

export const getCustomerStripeInformation = async () => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/payment/customer_stripe_information`,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}

export const addPaymentMethod = async (card) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data, card };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/payment/stripe_add_payment_method`,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {};
  }

  return resultState;
}


export const deletePaymentMethod = async (id) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data, id };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/payment/delete_payment_method`,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {};
  }

  return resultState;
}

export const getSubscriptionInfo = async () => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/payment/get_subscription_info`,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}

export const getDefaultPaymentMethod = async () => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  const data = {
    user: user_data,
  }

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: BASE_BACKEND_URL + `/payment/get_default_payment_method`,
      data,
      withCredentials: true
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {
    };
  }

  return resultState;
}


export const setDefaultPaymentMethod = async (id) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data, id };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/payment/set_default_payment_method`,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {};
  }

  return resultState;
}

export const cancelSubscription = async (id) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data, id };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/payment/stripe_cancel_subscription`,
      data: customer_data,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }).then(res => {
      resultState.state = 'success';
      resultState.data = res.data;
    }).catch((err) => {
      resultState.state = 'error';
      resultState.data['message'] = err.message;
    })
  } else {
    resultState.state = 'success';
    resultState.data = {};
  }

  return resultState;
}


// ==================== AI SHORTS ====================

export const AIShortShareLinkGet = async (uuid) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();

  let data = { user: user_data };

  let url = `${BASE_BACKEND_URL}/share/aishort/${uuid}/`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: data,
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = null; // AIShortManifestData;
  }

  return resultState;
}

export const AIShortShareLinkPost = async (aishort_uuid) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();

  let data = { user: user_data,
               aishort_uuid: aishort_uuid };

  let url = `${BASE_BACKEND_URL}/share/aishort/`;

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: url,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = null; // AIShortManifestData;
  }

  return resultState;
}


export const AIShortsForUserGet = async (queryParams = '') => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  
  let data = { user: user_data };

  let url = `${BASE_BACKEND_URL}/user/aishorts/${queryParams}`;
  
  // if (SERVER_STATUS !== 'localhost') {
  await axios({
    method: 'get',
    url: url,
    data: data,
    withCredentials: true,
  }).then(function (response) {
    resultState.state = 'success';
    resultState.data = response.data;
  }).catch(function (error) {
    resultState.state = 'error';
    resultState.data.message = error.message;
    window.toastr.error(error.message);
    })
  // } else {
  //   resultState.state = 'success';
  //   resultState.data = null; // AIShortManifestData;
  // }
    
  return resultState;
}

export const AIShortItemsForAIShortGet = async (aishort_uuid, sharelink_uuid = null) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  
  let data = { user: user_data };

  let url = `${BASE_BACKEND_URL}/user/aishort/${aishort_uuid}/items/`;

  if (sharelink_uuid) {
    url = `${BASE_BACKEND_URL}/user/aishort/${aishort_uuid}/sharelink/${sharelink_uuid}/items/`;
  }
  
  // if (SERVER_STATUS !== 'localhost') {
  await axios({
    method: 'get',
    url: url,
    data: data,
    withCredentials: true,
  }).then(function (response) {
    resultState.state = 'success';
    resultState.data = response.data;
  }).catch(function (error) {
    resultState.state = 'error';
    resultState.data.message = error.message;
    window.toastr.error(error.message);
    })
  // } else {
  //   resultState.state = 'success';
  //   resultState.data = null; // AIShortManifestData;
  // }
    
  return resultState;
}

export const AIShortManifestGetwithShareLink = async (asset_uuid, sharelink_uuid) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  
  let data = { user: user_data };

  let url = '';
  if (asset_uuid && sharelink_uuid) {
    url = `${BASE_BACKEND_URL}/aishort/${asset_uuid}/sharelink/${sharelink_uuid}/`;
  } else {
    url = `${BASE_BACKEND_URL}/aishort/`;
  }
  
  // if (SERVER_STATUS !== 'localhost') {
  await axios({
    method: 'get',
    url: url,
    data: data,
    withCredentials: true,
  }).then(function (response) {
    resultState.state = 'success';
    resultState.data = response.data;
  }).catch(function (error) {
    resultState.state = 'error';
    resultState.data.message = error.message;
    window.toastr.error(error.message);
    })
  // } else {
  //   resultState.state = 'success';
  //   resultState.data = null; // AIShortManifestData;
  // }
    
  return resultState;
}

export const AIShortManifestGet = async (uuid) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let data = { user: user_data };

  let url = '';
  if (uuid) {
    url = `${BASE_BACKEND_URL}/aishort/${uuid}/`;
  } else {
    url = `${BASE_BACKEND_URL}/aishort/`;
  }
  
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get',
      url: url,
      data: data,
      withCredentials: true,
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    })
  } else {
    resultState.state = 'success';
    resultState.data = null; // AIShortManifestData;
  }
    
  return resultState;
}

export const AIShortManifestPost = async (uuid, info) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let data = { user: user_data, info: info };

  let url = '';
  if (uuid) {
    url = `${BASE_BACKEND_URL}/aishort/${uuid}/`;
  } else {
    url = `${BASE_BACKEND_URL}/aishort/`;
  }
  
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post',
      url: url,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }
    ).catch(function (error) {
      resultState.state = 'error';
      if (error.response?.status === 402 && error.response?.data?.code === 'INSUFFICIENT_CREDITS') {
        resultState.data.code = 'INSUFFICIENT_CREDITS';
      } else {
        resultState.data.message = error.message;
        window.toastr.error(error.message);
      }
    }
    )
  } else {
    resultState.state = 'success';
    resultState.data = null; // AIShortManifestData;
  }

  return resultState;
}

// ---- AI Chapters (AIStars) ----

export const AIStarsCreate = async (info) => {
  let resultState = { state: '', data: {} };
  let data = { user: getAccessToken(), info: info };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post', url: `${BASE_BACKEND_URL}/aistars/`, data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => { resultState.state = 'success'; resultState.data = res.data; })
      .catch((err) => { resultState.state = 'error'; resultState.data.message = err.message; window.toastr.error(err.message); });
  } else { resultState.state = 'success'; resultState.data = null; }
  return resultState;
}

export const AIStarsGet = async (uuid) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get', url: `${BASE_BACKEND_URL}/aistars/${uuid}/`,
      data: { user: getAccessToken() }, withCredentials: true,
    }).then((res) => { resultState.state = 'success'; resultState.data = res.data; })
      .catch((err) => { resultState.state = 'error'; resultState.data.message = err.message; });
  } else { resultState.state = 'success'; resultState.data = null; }
  return resultState;
}

export const AIStarsUpdate = async (uuid, info) => {
  let resultState = { state: '', data: {} };
  let data = { user: getAccessToken(), info: info };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'put', url: `${BASE_BACKEND_URL}/aistars/${uuid}/`, data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => { resultState.state = 'success'; resultState.data = res.data; })
      .catch((err) => {
        resultState.state = 'error';
        if (err.response?.status === 402 && err.response?.data?.code === 'INSUFFICIENT_CREDITS') {
          resultState.data.code = 'INSUFFICIENT_CREDITS';
        } else {
          resultState.data.message = err.message; window.toastr.error(err.message);
        }
      });
  } else { resultState.state = 'success'; resultState.data = null; }
  return resultState;
}

export const AIStarsDelete = async (uuid) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'delete', url: `${BASE_BACKEND_URL}/aistars/${uuid}/`,
      data: { user: getAccessToken() }, headers: { 'Content-Type': 'application/json' },
    }).then((res) => { resultState.state = 'success'; resultState.data = res.data; })
      .catch((err) => { resultState.state = 'error'; resultState.data.message = err.message; });
  } else { resultState.state = 'success'; resultState.data = null; }
  return resultState;
}

export const AIStarsListGet = async () => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get', url: `${BASE_BACKEND_URL}/aistars/list/`,
      data: { user: getAccessToken() }, withCredentials: true,
    }).then((res) => { resultState.state = 'success'; resultState.data = res.data; })
      .catch((err) => { resultState.state = 'error'; resultState.data.message = err.message; });
  } else { resultState.state = 'success'; resultState.data = null; }
  return resultState;
}

export const AIStarsTranscriptGet = async (uuid) => {
  let resultState = { state: '', data: {} };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'get', url: `${BASE_BACKEND_URL}/aistars/${uuid}/transcript/`,
      data: { user: getAccessToken() }, withCredentials: true,
    }).then((res) => { resultState.state = 'success'; resultState.data = res.data; })
      .catch((err) => { resultState.state = 'error'; resultState.data.message = err.message; });
  } else { resultState.state = 'success'; resultState.data = null; }
  return resultState;
}

export const AIStarsExport = async (uuid, chapters, separate = false) => {
  let resultState = { state: '', data: {} };
  let data = { user: getAccessToken(), chapters: chapters, separate: separate };
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'post', url: `${BASE_BACKEND_URL}/aistars/${uuid}/export/`, data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => { resultState.state = 'success'; resultState.data = res.data; })
      .catch((err) => { resultState.state = 'error'; resultState.data.message = err.message; window.toastr.error(err.message); });
  } else { resultState.state = 'success'; resultState.data = null; }
  return resultState;
}

export const AIShortManifestUpdate = async (uuid, info) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let data = { user: user_data, info: info };

  let url = '';
  if (uuid) {
    url = `${BASE_BACKEND_URL}/aishort/${uuid}/`;
  } else {
    url = `${BASE_BACKEND_URL}/aishort/`;
  }
  
  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'put',
      url: url,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }
    ).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      // window.toastr.error(error.message);
    }
    )
  } else {
    resultState.state = 'success';
    resultState.data = null; // AIShortManifestData;
  }
    
  return resultState;
}

export const AIShortManifestDelete = async (uuid) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();

  let data = { user: user_data };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'delete',
      url: `${BASE_BACKEND_URL}/aishort/${uuid}/`,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }
    ).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    }
    )
  } else {
    resultState.state = 'success';
    resultState.data = null; // AIShortManifestData;
  }

  return resultState;
}

// Delete a single AIShortItem. Owner-gated on the backend (only the owner of
// the parent aishort may delete its items); mirrors AIShortManifestDelete's
// body-token auth so it works from both the popup and the share page.
export const AIShortItemDelete = async (aishort_uuid, item_uuid) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();

  let data = { user: user_data };

  if (SERVER_STATUS !== 'localhost') {
    await axios({
      method: 'delete',
      url: `${BASE_BACKEND_URL}/aishort/${aishort_uuid}/item/${item_uuid}/`,
      data: data,
      headers: { 'Content-Type': 'application/json' },
    }).then(function (response) {
      resultState.state = 'success';
      resultState.data = response.data;
    }
    ).catch(function (error) {
      resultState.state = 'error';
      resultState.data.message = error.message;
      window.toastr.error(error.message);
    }
    )
  } else {
    resultState.state = 'success';
    resultState.data = null;
  }

  return resultState;
}

export const AIShortItemManifestGet = async (uuid, item_uuid) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let customer_data = { user: user_data };
  
  // if (SERVER_STATUS !== 'localhost') {
  await axios({
    method: 'get',
    url: `${BASE_BACKEND_URL}/aishort/${uuid}/item/${item_uuid}`,
    data: customer_data,
    withCredentials: true,
  }).then(function (response) {
    resultState.state = 'success';
    resultState.data = response.data;
  }).catch(function (error) {
    resultState.state = 'error';
    resultState.data.message = error.message;
    window.toastr.error(error.message);
  })

  // else {
  //   resultState.state = 'success';
  //   resultState.data = null; // AIShortManifestData;
  // }
    
  return resultState;
}

export const AIShortItemCreateFromFocus = async (aishort_uuid, body) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let data = { user: user_data, info: body };

  await axios({
    method: 'post',
    url: `${BASE_BACKEND_URL}/aishort/${aishort_uuid}/item/from-focus/`,
    data: data,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).then(function (response) {
    resultState.state = 'success';
    resultState.data = response.data;
  }).catch(function (error) {
    resultState.state = 'error';
    resultState.data.message = error.message;
    if (window.toastr) window.toastr.error(error.message);
  });

  return resultState;
};

export const updateAIShortItemFocus = async (aishort_uuid, item_uuid, forced_focus_entities) => {
  let resultState = { state: '', data: {} };

  await axios({
    method: 'patch',
    url: `${BASE_BACKEND_URL}/aishort/${aishort_uuid}/item/${item_uuid}/`,
    data: { forced_focus_entities },
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }).then(function (response) {
    resultState.state = 'success';
    resultState.data = response.data;
  }).catch(function (error) {
    resultState.state = 'error';
    resultState.data.message = error.message;
  });

  return resultState;
};

export const AIShortItemManifestPost = async (uuid, item_uuid, info) => {
  let resultState = { state: '', data: {} };
  let user_data = getAccessToken();
  let data = { user: user_data, info: info };
  
  // if (SERVER_STATUS !== 'localhost') {
  await axios({
    method: 'post',
    url: `${BASE_BACKEND_URL}/aishort/${uuid}/item/${item_uuid}`,
    data: data,
    headers: { 'Content-Type': 'application/json' },
  }).then(function (response) {
    resultState.state = 'success';
    resultState.data = response.data;
  }
  ).catch(function (error) {
    resultState.state = 'error';
    resultState.data.message = error.message;
    window.toastr.error(error.message);
  }
  )
  // else {
  //   resultState.state = 'success';
  //   resultState.data = null; // AIShortManifestData;
  // }
    
  return resultState;
}

// ─── AI Video (fal.ai) ───────────────────────────────────────────────────────

export const getAIVideos = async (url) => {
  let resultState = { state: '', data: {} };
  try {
    const res = await axios({
      method: 'get',
      url: url || `${BASE_BACKEND_URL}/user/aivideos/`,
      withCredentials: true,
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};

export const createAIVideo = async ({ prompt, model, image_url, input_asset_uuid, end_input_asset_uuid, kling3_options }) => {
  let resultState = { state: '', data: {} };
  const user_data = getAccessToken();
  try {
    const res = await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/aivideo/`,
      data: { user: user_data, prompt, model, image_url, input_asset_uuid, end_input_asset_uuid, kling3_options },
      headers: { 'Content-Type': 'application/json' },
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    if (err.response?.status === 402 && err.response?.data?.code === 'INSUFFICIENT_CREDITS') {
      resultState.data.code = 'INSUFFICIENT_CREDITS';
    } else {
      resultState.data.message = err.message;
    }
  }
  return resultState;
};

export const CreateImageAsset = async ({ title, original_filename, mime_type, category, size, thumbnail_info }) => {
  let resultState = { state: '', data: {} };
  const user_data = getAccessToken();
  try {
    const res = await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/asset/create/`,
      data: { user: user_data, title, original_filename, mime_type, category, size, thumbnail_info },
      headers: { 'Content-Type': 'application/json' },
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};

export const updateAssetState = async (asset_uuid, state, progress = 100) => {
  let resultState = { state: '', data: {} };
  try {
    const res = await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/asset/${asset_uuid}/update/?state=${state}&progress=${progress}`,
      withCredentials: true,
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};

export const deleteAIVideo = async (uuid) => {
  let resultState = { state: '', data: {} };
  const user_data = getAccessToken();
  try {
    const res = await axios({
      method: 'delete',
      url: `${BASE_BACKEND_URL}/aivideo/`,
      data: { user: user_data, uuid },
      headers: { 'Content-Type': 'application/json' },
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};

export const pollAIVideo = async (aivideo_uuid) => {
  let resultState = { state: '', data: {} };
  const user_data = getAccessToken();
  try {
    const res = await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/aivideo/`,
      data: { user: user_data, check_uuid: aivideo_uuid },
      headers: { 'Content-Type': 'application/json' },
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};

// ---- AI Dubbing timeline editor ----

export const getDubbingEditor = async (voiceclone_uuid) => {
  let resultState = { state: '', data: {} };
  try {
    const res = await axios({
      method: 'get',
      url: `${BASE_BACKEND_URL}/voiceclone/${voiceclone_uuid}/segments/`,
      withCredentials: true,
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};

// Unsafe methods follow the house pattern: user token in the BODY and NO
// withCredentials. Sending the session cookie makes DRF's SessionAuthentication
// enforce CSRF (the token cookie is HttpOnly + session-stored here, so the SPA
// can never satisfy it) -> 403. GETs keep cookies; writes carry the body token.
export const saveDubbingLayout = async (voiceclone_uuid, segments, editorConfig) => {
  let resultState = { state: '', data: {} };
  try {
    const res = await axios({
      method: 'put',
      url: `${BASE_BACKEND_URL}/voiceclone/${voiceclone_uuid}/segments/`,
      data: { user: getAccessToken(), segments: segments, editor_config: editorConfig },
      headers: { 'Content-Type': 'application/json' },
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};

export const startDubbingRemix = async (voiceclone_uuid, editorConfig) => {
  let resultState = { state: '', data: {} };
  try {
    const res = await axios({
      method: 'post',
      url: `${BASE_BACKEND_URL}/voiceclone/${voiceclone_uuid}/remix/`,
      data: { user: getAccessToken(), editor_config: editorConfig },
      headers: { 'Content-Type': 'application/json' },
    });
    resultState.state = 'success';
    resultState.data = res.data;
  } catch (err) {
    resultState.state = 'error';
    resultState.data.message = err.message;
  }
  return resultState;
};
